function initPasswordToggles() {
    document.querySelectorAll('[data-password-toggle]').forEach((wrapper) => {
        const input = wrapper.querySelector('input');
        const button = wrapper.querySelector('[data-password-toggle-btn]');

        if (!input || !button) {
            return;
        }

        button.addEventListener('click', () => {
            const willShow = input.type === 'password';
            input.type = willShow ? 'text' : 'password';
            wrapper.classList.toggle('is-visible', willShow);
            button.setAttribute('aria-label', willShow ? 'Masquer le mot de passe' : 'Afficher le mot de passe');
        });
    });
}

export default initPasswordToggles;
